import { inject, Injectable } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { Response } from '../../../../_shared/models/response.model';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { KpiStatsResponse } from '../../../../_shared/models/kpi-response.model';
import { ComplianceKpiRequest } from '../models/compliance-kpi.model';

@Injectable({
  providedIn: 'root'
})
export class ComplianceService {
  private httpClient = inject(HttpClient);

  async getNonCompliantKpiStatsAsync(request: ComplianceKpiRequest, cancelSubject: Subject<void>): Promise<Response<KpiStatsResponse>> {
    return await firstValueFrom(
      this.httpClient.post(`${environment.apiEndpoint}/compliance/non-compliant-summary`, request).pipe(takeUntil(cancelSubject))
    );
  }

  async getCompliantKpiStatsAsync(request: ComplianceKpiRequest, cancelSubject: Subject<void>): Promise<Response<KpiStatsResponse>> {
    return await firstValueFrom(
      this.httpClient.post(`${environment.apiEndpoint}/compliance/compliant-summary`, request).pipe(takeUntil(cancelSubject))
    );
  }

  async getExpiringDocumentsKpiStatsAsync(request: ComplianceKpiRequest, cancelSubject: Subject<void>): Promise<Response<KpiStatsResponse>> {
    return await firstValueFrom(
      this.httpClient.post(`${environment.apiEndpoint}/compliance/expiring-soon-summary`, request).pipe(takeUntil(cancelSubject))
    );
  }

  async getInspectionPassRateKpiStatsAsync(request: ComplianceKpiRequest, cancelSubject: Subject<void>): Promise<Response<KpiStatsResponse>> {
    return await firstValueFrom(
      this.httpClient.post(`${environment.apiEndpoint}/compliance/inspection-pass-rate-summary`, request).pipe(takeUntil(cancelSubject))
    );
  }
}